import { CompassCardUI } from '@scale/compass-ui/types';
import {
  CalendarDataGeneratorCardShared,
  CalendarDataGeneratorSchemaType,
  CALENDAR_DATA_GENERATOR,
  Locale,
} from '@scale/genai-compass-shared/cards/calendar_data_generator';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons';
import CalendarDataGeneratorCardComponent from './CalendarDataGeneratorCardComponent';

// Helper function to format date as YYYY-MM-DD
const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Helper function to add months to a date
const addMonths = (date: Date, months: number): Date => {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
};

// Calculate default dates
const today = new Date();
const earliestDate = formatDate(addMonths(today, 2)); // 2 months after today
const latestDate = formatDate(addMonths(today, 4)); // 4 months after today

export const CalendarDataGeneratorCardInput: CompassCardUI<CalendarDataGeneratorSchemaType> = {
  ...CalendarDataGeneratorCardShared,
  title: 'Calendar Data Generator',
  icon: 'calendar',
  toolTip: 'Generate synthetic calendar data for testing',
  defaultContext: {
    cardType: CALENDAR_DATA_GENERATOR,
    rowsToGenerate: 100,
    locales: [Locale.en_US],
    minCalendars: 1,
    maxCalendars: 3,
    minEvents: 1,
    maxEvents: 10,
    earliestDate,
    latestDate,
    maxUsers: 5,
  },
  button: {
    icon: faCalendar,
    title: 'Calendar Data Generator',
  },
  component: CalendarDataGeneratorCardComponent,
  showOutput: true, // Show the results table after execution
};
